<template>
  <q-field
    :error="errors.has('customer')"
    :error-label="errors.first('customer')"
  >
    <q-search
      v-model="customerInput"
      name="customer-search"
      :placeholder="$tc('customer', 1)"
      v-bind="$attrs"
      :class="{ 'no-shadow': noShadow }"
    >
      <infinite-autocomplete
        ref="autocomplete"
        @fetch="handleInfiniteScroll"
        @search="handleSearch"
        @selected="handleSelect"
        :debounce="defaultSearchDebounce"
        :min-characters="0"
        :max-results="200"
        :max-height="'300px'"
        :value-field="v => getCustomerName(v.value)"
      />
    </q-search>
  </q-field>
</template>

<script>
  import { CustomersClient } from 'src/api/Customers'
  import InfiniteAutocomplete from 'components/Common/InfiniteAutocomplete.vue'
  import { customerTypes } from 'src/utils/customerTypes'
  import debounceMixin from 'src/utils/mixins/debounce'
  import { getCustomerName } from 'src/utils/searchResultParser'

  export default {
    inject: ['$validator'],

    data () {
      return {
        customerInput: '',
        customer: null
      }
    },

    props: {
      value: {
        required: true
      },

      noShadow: {
        type: Boolean,
        requried: false,
        default: false
      },

      types: {
        required: false,
        default: () => [customerTypes.COMPANY, customerTypes.PERSON],
        type: Array
      }
    },

    computed: {
      customerName () {
        if (!this.customer) {
          return null
        }

        return getCustomerName(this.customer)
      },

      filters () {
        return ['type', '=', this.types]
      }
    },

    methods: {
      getCustomerName,

      handleSearch (query, done) {
        this.executeSearch(query)
          .then(response => {
            const isLastPage = response.data.meta.pagination.current_page === response.data.meta.pagination.total_pages

            done(this.mapSearchResponse(response.data.data), isLastPage)
          })
      },

      executeSearch (term) {
        const client = new CustomersClient()
          .filter(this.filters)

        if (!term) {
          return client.sort('name:asc')
            .list()
        }

        return client.search(term)
      },

      handleInfiniteScroll (query, index, done) {
        if (query) {
          done([], true)
          return
        }

        new CustomersClient()
          .sort('name:asc')
          .page(index + 1)
          .filter(this.filters)
          .list()
          .then(response => {
            const isLastPage = response.data.meta.pagination.current_page === response.data.meta.pagination.total_pages

            return done(this.mapSearchResponse(response.data.data), isLastPage)
          })
      },

      mapSearchResponse (data) {
        return data.map(entry => {
          return {
            value: entry,
            label: getCustomerName(entry),
            sublabel: `#${entry.customer_number}`,
            icon: entry.type === 'person' ? 'person' : 'business'
          }
        })
      },

      handleSelect (item) {
        this.customerInput = item.label
        this.customer = item.value
      },

      handleCustomerDeselect () {
        this.customerInput = ''
        this.customer = null
      }
    },

    watch: {
      customer () {
        this.$emit('input', this.customer)
      },

      customerInput (newVal) {
        if (newVal === '') {
          this.$emit('input', null)
        }
      },

      value (val) {
        this.customer = val
        this.customerInput = val ? (getCustomerName(val)) : ''
      }
    },

    components: {
      InfiniteAutocomplete
    },

    mixins: [
      debounceMixin
    ]
  }
</script>
